function a(t, r) {
  return "".concat(e(t)).concat(r);
}
var o = 26;
function e(t) {
  if (typeof t != "number")
    return "";
  var r = Math.floor(t / o), n = String.fromCharCode(97 + t % o).toUpperCase();
  return r === 0 ? n : e(r - 1) + n;
}
export {
  a as default
};
//# sourceMappingURL=index.es519.js.map
